import { useMedplum } from '@medplum/react';
import { FC, useEffect } from 'react';
import { ConfigService } from '@services/config.service';

export const ClientApplicationLoader: FC = () => {
  const medplum = useMedplum();

  useEffect(() => {
    const login = async (): Promise<void> => {
      await medplum.startClientLogin(
        ConfigService.getClientId(),
        ConfigService.getClientSecret()
      );
    };

    login();
  }, [medplum]);

  return null;
};
